import { TIME_FRAMES } from '../constants';
import type { Timeframe } from '../types';
import { cn } from '../utils/format';

interface Props {
  value: Timeframe;
  onChange: (timeframe: Timeframe) => void;
}

export function TimeframeToggle({ value, onChange }: Props) {
  return (
    <div className="inline-flex rounded-xl border border-zinc-800 bg-zinc-900 p-1">
      {TIME_FRAMES.map((tf) => (
        <button
          key={tf.value}
          type="button"
          onClick={() => onChange(tf.value)}
          className={cn(
            'rounded-lg px-4 py-1.5 text-sm font-semibold transition-colors',
            value === tf.value
              ? 'bg-zinc-700 text-zinc-100 shadow-md shadow-black/30'
              : 'text-zinc-500 hover:text-zinc-300',
          )}
        >
          {tf.label}
        </button>
      ))}
    </div>
  );
}
